import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  rootBox: {
    justifyContent: 'flex-start',
    width: '75%',
    padding: theme.spacing(2),
    margin: 'auto',
    display: 'flex',
    backgroundColor: 'white',
  },
  pageTitleContainer: {
    padding: theme.spacing(1),
    alignItems: 'center',
    backgroundColor: '#DFE5E9',
  },
  welcome: {
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
      fontSize: '75%',
    },
  },
  welcomeText: {
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
      fontSize: '75%',
    },
  },
  logoGrid: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex-start',
    },
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
    },
  },
  logoCard: {
    backgroundColor: 'transparent',
    height: '100px',
    width: '100px',
  },
  button: {
    margin: theme.spacing(1),
  },
  avatarGrid: {
    marginTop: 15,
    marginBottom: 15,
  },
  contactChannelContainer: {
    marginTop: 5,
    marginBottom: 6,
    alignItems: 'center',
  },
  contactChannelValueGrid: {
    textAlign: 'end',
  },
  submitButtonGrid: {
    textAlign: 'center',
    marginTop: 50,
  },
  errorMessage: {
    color: 'red',
  },
}));
